import { apiClient, apiFetch } from '@/shared/api';
import { UiSettings } from '@/entities/settings/models/types';
import { ChangePasswordRequest, ProfileData, UpdateProfileRequest, UpdateProfileResponse } from '../types';

// GET /profile/me - get current user profile
export const fetchMyProfile = async () => {
  const { data } = await apiClient.get<ProfileData>('/profile/me');
  return data;
};

/**
 * Смена собственного пароля в профиле (POST /profile/change-password).
 * Об отказе сообщает диалог смены пароля: по правилам пароля — у поля, прочие — уведомлением,
 * поэтому общее уведомление не поднимается.
 */
export const changeMyPassword = async (payload: ChangePasswordRequest) => {
  const { data } = await apiClient.post<unknown>('/profile/change-password', payload, { silentError: true });
  return data;
};

// PUT /profile/update - update current user profile
export const updateMyProfile = async (payload: UpdateProfileRequest) => {
  const { data } = await apiClient.put<UpdateProfileResponse>('/profile/update', payload);
  return data;
};

// PUT /profile/ui-settings - сохранение настроек интерфейса пользователя
export const updateUiSettings = async (uiSettings: UiSettings) => {
  const { data } = await apiClient.put<{ uiSettings: UiSettings }>('/profile/ui-settings', {
    uiSettings,
  });
  return data;
};

/**
 * Сохранение настроек интерфейса, переживающее уход со страницы: обычный запрос браузер обрывает
 * вместе с выгрузкой документа, поэтому перезагрузка сразу за настройкой теряла бы её. Запрос
 * с `keepalive` браузер доводит до конца сам, уже без страницы.
 *
 * Ответ никого не ждёт: страницы, пославшей запрос, к его завершению может не быть.
 */
export const sendUiSettingsOnUnload = (uiSettings: UiSettings): void => {
  // Запрос идёт мимо `apiClient`: `keepalive` axios не умеет, а без него браузер обрывает запрос
  // вместе со страницей. Адрес, авторизация и куки при этом остаются клиентскими.
  void apiFetch('/profile/ui-settings', {
    method: 'PUT',
    keepalive: true,
    body: JSON.stringify({ uiSettings }),
  }).catch(() => {
    // Сбой отправки показывать уже некому: страницы к этому времени нет
  });
};
